/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as TermsRouteImport } from './routes/terms'
import { Route as StandingsRouteImport } from './routes/standings'
import { Route as SignupRouteImport } from './routes/signup'
import { Route as ResetPasswordRouteImport } from './routes/reset-password'
import { Route as PrivacyPolicyRouteImport } from './routes/privacy-policy'
import { Route as LoginRouteImport } from './routes/login'
import { Route as AppRouteImport } from './routes/_app'
import { Route as IndexRouteImport } from './routes/index'
import { Route as JoinLeagueCodeRouteImport } from './routes/join.$leagueCode'
import { Route as AppRulesRouteImport } from './routes/_app/rules'
import { Route as AppProfileRouteImport } from './routes/_app/profile'
import { Route as AppPredictionsRouteImport } from './routes/_app/predictions'
import { Route as AppNotificationsRouteImport } from './routes/_app/notifications'
import { Route as AppAdminRouteImport } from './routes/_app/admin'
import { Route as AppLeaguesIndexRouteImport } from './routes/_app/leagues.index'
import { Route as AppPlayersIdRouteImport } from './routes/_app/players.$id'
import { Route as AppLeaguesCodeRouteImport } from './routes/_app/leagues.$code'

const TermsRoute = TermsRouteImport.update({
  id: '/terms',
  path: '/terms',
  getParentRoute: () => rootRouteImport,
} as any)
const StandingsRoute = StandingsRouteImport.update({
  id: '/standings',
  path: '/standings',
  getParentRoute: () => rootRouteImport,
} as any)
const SignupRoute = SignupRouteImport.update({
  id: '/signup',
  path: '/signup',
  getParentRoute: () => rootRouteImport,
} as any)
const ResetPasswordRoute = ResetPasswordRouteImport.update({
  id: '/reset-password',
  path: '/reset-password',
  getParentRoute: () => rootRouteImport,
} as any)
const PrivacyPolicyRoute = PrivacyPolicyRouteImport.update({
  id: '/privacy-policy',
  path: '/privacy-policy',
  getParentRoute: () => rootRouteImport,
} as any)
const LoginRoute = LoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => rootRouteImport,
} as any)
const AppRoute = AppRouteImport.update({
  id: '/_app',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const JoinLeagueCodeRoute = JoinLeagueCodeRouteImport.update({
  id: '/join/$leagueCode',
  path: '/join/$leagueCode',
  getParentRoute: () => rootRouteImport,
} as any)
const AppRulesRoute = AppRulesRouteImport.update({
  id: '/rules',
  path: '/rules',
  getParentRoute: () => AppRoute,
} as any)
const AppProfileRoute = AppProfileRouteImport.update({
  id: '/profile',
  path: '/profile',
  getParentRoute: () => AppRoute,
} as any)
const AppPredictionsRoute = AppPredictionsRouteImport.update({
  id: '/predictions',
  path: '/predictions',
  getParentRoute: () => AppRoute,
} as any)
const AppNotificationsRoute = AppNotificationsRouteImport.update({
  id: '/notifications',
  path: '/notifications',
  getParentRoute: () => AppRoute,
} as any)
const AppAdminRoute = AppAdminRouteImport.update({
  id: '/admin',
  path: '/admin',
  getParentRoute: () => AppRoute,
} as any)
const AppLeaguesIndexRoute = AppLeaguesIndexRouteImport.update({
  id: '/leagues/',
  path: '/leagues/',
  getParentRoute: () => AppRoute,
} as any)
const AppPlayersIdRoute = AppPlayersIdRouteImport.update({
  id: '/players/$id',
  path: '/players/$id',
  getParentRoute: () => AppRoute,
} as any)
const AppLeaguesCodeRoute = AppLeaguesCodeRouteImport.update({
  id: '/leagues/$code',
  path: '/leagues/$code',
  getParentRoute: () => AppRoute,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/login': typeof LoginRoute
  '/privacy-policy': typeof PrivacyPolicyRoute
  '/reset-password': typeof ResetPasswordRoute
  '/signup': typeof SignupRoute
  '/standings': typeof StandingsRoute
  '/terms': typeof TermsRoute
  '/admin': typeof AppAdminRoute
  '/notifications': typeof AppNotificationsRoute
  '/predictions': typeof AppPredictionsRoute
  '/profile': typeof AppProfileRoute
  '/rules': typeof AppRulesRoute
  '/join/$leagueCode': typeof JoinLeagueCodeRoute
  '/leagues/$code': typeof AppLeaguesCodeRoute
  '/players/$id': typeof AppPlayersIdRoute
  '/leagues/': typeof AppLeaguesIndexRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/login': typeof LoginRoute
  '/privacy-policy': typeof PrivacyPolicyRoute
  '/reset-password': typeof ResetPasswordRoute
  '/signup': typeof SignupRoute
  '/standings': typeof StandingsRoute
  '/terms': typeof TermsRoute
  '/admin': typeof AppAdminRoute
  '/notifications': typeof AppNotificationsRoute
  '/predictions': typeof AppPredictionsRoute
  '/profile': typeof AppProfileRoute
  '/rules': typeof AppRulesRoute
  '/join/$leagueCode': typeof JoinLeagueCodeRoute
  '/leagues/$code': typeof AppLeaguesCodeRoute
  '/players/$id': typeof AppPlayersIdRoute
  '/leagues': typeof AppLeaguesIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/_app': typeof AppRouteWithChildren
  '/login': typeof LoginRoute
  '/privacy-policy': typeof PrivacyPolicyRoute
  '/reset-password': typeof ResetPasswordRoute
  '/signup': typeof SignupRoute
  '/standings': typeof StandingsRoute
  '/terms': typeof TermsRoute
  '/_app/admin': typeof AppAdminRoute
  '/_app/notifications': typeof AppNotificationsRoute
  '/_app/predictions': typeof AppPredictionsRoute
  '/_app/profile': typeof AppProfileRoute
  '/_app/rules': typeof AppRulesRoute
  '/join/$leagueCode': typeof JoinLeagueCodeRoute
  '/_app/leagues/$code': typeof AppLeaguesCodeRoute
  '/_app/players/$id': typeof AppPlayersIdRoute
  '/_app/leagues/': typeof AppLeaguesIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/login'
    | '/privacy-policy'
    | '/reset-password'
    | '/signup'
    | '/standings'
    | '/terms'
    | '/admin'
    | '/notifications'
    | '/predictions'
    | '/profile'
    | '/rules'
    | '/join/$leagueCode'
    | '/leagues/$code'
    | '/players/$id'
    | '/leagues/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/login'
    | '/privacy-policy'
    | '/reset-password'
    | '/signup'
    | '/standings'
    | '/terms'
    | '/admin'
    | '/notifications'
    | '/predictions'
    | '/profile'
    | '/rules'
    | '/join/$leagueCode'
    | '/leagues/$code'
    | '/players/$id'
    | '/leagues'
  id:
    | '__root__'
    | '/'
    | '/_app'
    | '/login'
    | '/privacy-policy'
    | '/reset-password'
    | '/signup'
    | '/standings'
    | '/terms'
    | '/_app/admin'
    | '/_app/notifications'
    | '/_app/predictions'
    | '/_app/profile'
    | '/_app/rules'
    | '/join/$leagueCode'
    | '/_app/leagues/$code'
    | '/_app/players/$id'
    | '/_app/leagues/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  AppRoute: typeof AppRouteWithChildren
  LoginRoute: typeof LoginRoute
  PrivacyPolicyRoute: typeof PrivacyPolicyRoute
  ResetPasswordRoute: typeof ResetPasswordRoute
  SignupRoute: typeof SignupRoute
  StandingsRoute: typeof StandingsRoute
  TermsRoute: typeof TermsRoute
  JoinLeagueCodeRoute: typeof JoinLeagueCodeRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/terms': {
      id: '/terms'
      path: '/terms'
      fullPath: '/terms'
      preLoaderRoute: typeof TermsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/standings': {
      id: '/standings'
      path: '/standings'
      fullPath: '/standings'
      preLoaderRoute: typeof StandingsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/signup': {
      id: '/signup'
      path: '/signup'
      fullPath: '/signup'
      preLoaderRoute: typeof SignupRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/reset-password': {
      id: '/reset-password'
      path: '/reset-password'
      fullPath: '/reset-password'
      preLoaderRoute: typeof ResetPasswordRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/privacy-policy': {
      id: '/privacy-policy'
      path: '/privacy-policy'
      fullPath: '/privacy-policy'
      preLoaderRoute: typeof PrivacyPolicyRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/login': {
      id: '/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_app': {
      id: '/_app'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AppRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/join/$leagueCode': {
      id: '/join/$leagueCode'
      path: '/join/$leagueCode'
      fullPath: '/join/$leagueCode'
      preLoaderRoute: typeof JoinLeagueCodeRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_app/rules': {
      id: '/_app/rules'
      path: '/rules'
      fullPath: '/rules'
      preLoaderRoute: typeof AppRulesRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/profile': {
      id: '/_app/profile'
      path: '/profile'
      fullPath: '/profile'
      preLoaderRoute: typeof AppProfileRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/predictions': {
      id: '/_app/predictions'
      path: '/predictions'
      fullPath: '/predictions'
      preLoaderRoute: typeof AppPredictionsRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/notifications': {
      id: '/_app/notifications'
      path: '/notifications'
      fullPath: '/notifications'
      preLoaderRoute: typeof AppNotificationsRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/admin': {
      id: '/_app/admin'
      path: '/admin'
      fullPath: '/admin'
      preLoaderRoute: typeof AppAdminRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/leagues/': {
      id: '/_app/leagues/'
      path: '/leagues'
      fullPath: '/leagues/'
      preLoaderRoute: typeof AppLeaguesIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/players/$id': {
      id: '/_app/players/$id'
      path: '/players/$id'
      fullPath: '/players/$id'
      preLoaderRoute: typeof AppPlayersIdRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/leagues/$code': {
      id: '/_app/leagues/$code'
      path: '/leagues/$code'
      fullPath: '/leagues/$code'
      preLoaderRoute: typeof AppLeaguesCodeRouteImport
      parentRoute: typeof AppRoute
    }
  }
}

interface AppRouteChildren {
  AppAdminRoute: typeof AppAdminRoute
  AppNotificationsRoute: typeof AppNotificationsRoute
  AppPredictionsRoute: typeof AppPredictionsRoute
  AppProfileRoute: typeof AppProfileRoute
  AppRulesRoute: typeof AppRulesRoute
  AppLeaguesCodeRoute: typeof AppLeaguesCodeRoute
  AppPlayersIdRoute: typeof AppPlayersIdRoute
  AppLeaguesIndexRoute: typeof AppLeaguesIndexRoute
}

const AppRouteChildren: AppRouteChildren = {
  AppAdminRoute: AppAdminRoute,
  AppNotificationsRoute: AppNotificationsRoute,
  AppPredictionsRoute: AppPredictionsRoute,
  AppProfileRoute: AppProfileRoute,
  AppRulesRoute: AppRulesRoute,
  AppLeaguesCodeRoute: AppLeaguesCodeRoute,
  AppPlayersIdRoute: AppPlayersIdRoute,
  AppLeaguesIndexRoute: AppLeaguesIndexRoute,
}

const AppRouteWithChildren = AppRoute._addFileChildren(AppRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  AppRoute: AppRouteWithChildren,
  LoginRoute: LoginRoute,
  PrivacyPolicyRoute: PrivacyPolicyRoute,
  ResetPasswordRoute: ResetPasswordRoute,
  SignupRoute: SignupRoute,
  StandingsRoute: StandingsRoute,
  TermsRoute: TermsRoute,
  JoinLeagueCodeRoute: JoinLeagueCodeRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
